import { executeApiCall } from 'services/api';
import { getLoaders } from 'entities/hooks/load';
import {
  FullRecruitment,
  Recruitment,
  RecruitmentByStatus,
  RecruitmentComment,
  SampleRecruitmentProject,
} from '../types';
import { WithUsers } from '../../users';

export const recruitmentLoaders = getLoaders({
  getRecruitmentCounts: {
    load: async (): Promise<Record<string, number>> => {
      return executeApiCall({
        path: `/projects/recruitments/status-counts`,

        method: 'get',
      });
    },
  },

  listActiveRecruitments: {
    load: async (): Promise<WithUsers<Recruitment, 'owner'>[]> => {
      return executeApiCall({
        path: `/projects/recruitments/active`,

        method: 'get',
      });
    },
  },

  listUnassignedRecruitments: {
    load: async (): Promise<WithUsers<Recruitment, 'requestedBy' | 'owner'>[]> => {
      return executeApiCall({
        path: `/projects/recruitments/unassigned`,

        method: 'get',
      });
    },
  },

  listProjectRecruitments: {
    load: async ({
      projectId,
    }: {
      projectId: string;
    }): Promise<WithUsers<Recruitment, 'owner'>[]> => {
      return executeApiCall({
        path: `/projects/recruitments/project/${projectId}`,

        method: 'get',
      });
    },
  },

  listRecruitmentsByStatus: {
    load: async (payload: {
      status: string;
      startDate?: string;
      endDate?: string;
      paginationToken?: string;
    }): Promise<RecruitmentByStatus[]> => {
      return executeApiCall({
        path: `/projects/recruitments/by-status`,

        method: 'get',

        payload,
      });
    },
  },

  findRecruitment: {
    load: async ({ recruitmentId }: { recruitmentId: string }): Promise<FullRecruitment> => {
      return executeApiCall({
        path: `/projects/recruitments/${recruitmentId}`,

        method: 'get',
      });
    },
  },

  getRecruitmentSampleProject: {
    load: async ({
      recruitmentId,
    }: {
      recruitmentId: string;
    }): Promise<SampleRecruitmentProject> => {
      return executeApiCall({
        path: `/projects/recruitments/${recruitmentId}/sample`,

        method: 'get',
      });
    },
  },

  recruitmentCommentHistory: {
    load: async ({ id }: { id: string }): Promise<RecruitmentComment[]> => {
      return executeApiCall({
        path: `/projects/recruitments/comments/history/${id}`,

        method: 'get',
      });
    },
  },
});
